import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import { animations, helpers } from "@styles";

export const tag = (theme: Theme) => css`
  ${animations.transition()}

  height: auto;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: ${borders.radiusPill};
  display: inline-flex;
  align-items: center;

  &:active,
  &:focus {
    svg path {
      fill: ${theme.system.borderActive};
    }
  }
`;

export const label = css`
  margin-right: 0.25rem;
  ${helpers.ellipsesOverflowHelper};
  max-width: 9.375rem;
`;

export const noEllipses = css`
  max-width: 100%;
`;

export const baseSystemProfile = (theme: Theme) => css`
  background-color: ${theme.system.backgroundBase};
  border: 1px solid ${theme.system.borderBase};
  color: ${theme.text.emphasis};

  &:hover {
    border-color: ${theme.primary.borderHover};
  }

  &:active,
  &:focus {
    background-color: ${theme.primary.backgroundMuted};
    border-color: ${theme.primary.borderActive};
  }
`;

export const closeButton = (theme: Theme) => css`
  cursor: pointer;
  color: ${theme.text.body};

  &:disabled {
    cursor: not-allowed;
    color: ${theme.disabled.text};
  }
`;

export const disabled = (theme: Theme) => css`
  & {
    cursor: not-allowed;
    background-color: ${theme.disabled.background};
    border: 1px solid ${theme.disabled.border};
    color: ${theme.disabled.text};
  }

  &:hover,
  &:active,
  &:focus {
    border-color: ${theme.disabled.border};
    color: ${theme.disabled.text};
    background-color: ${theme.disabled.background};
  }
`;
